const FLOATING_MENU_HANDLED_KEYS = new Set([
  "ArrowDown",
  "ArrowUp",
  "Enter",
  " ",
]);

const elementContains = (container, node) => {
  if (!container || !node || typeof container.contains !== "function") {
    return false;
  }

  return container.contains(node);
};

export const isEditableEventTarget = (target) => {
  if (!target || typeof window === "undefined") {
    return false;
  }

  const tagName = (target.tagName || "").toLowerCase();
  if (tagName === "input" || tagName === "textarea" || tagName === "select") {
    return true;
  }

  return target.isContentEditable === true;
};

export const resolveFloatingMenuKeyHandling = ({
  event,
  floatingElement,
  activeElement,
  captureKeyboardWhenOpen = false,
} = {}) => {
  const key = event?.key;
  if (!FLOATING_MENU_HANDLED_KEYS.has(key)) {
    return {
      shouldHandle: false,
      shouldCapture: false,
      isInsideFloating: false,
    };
  }

  const isActiveInsideFloating = elementContains(floatingElement, activeElement);
  const isTargetInsideFloating = elementContains(floatingElement, event?.target);
  const isInsideFloating = isActiveInsideFloating || isTargetInsideFloating;

  if (isInsideFloating) {
    return {
      shouldHandle: true,
      shouldCapture: false,
      isInsideFloating: true,
    };
  }

  if (!captureKeyboardWhenOpen) {
    return {
      shouldHandle: false,
      shouldCapture: false,
      isInsideFloating: false,
    };
  }

  if (isEditableEventTarget(event?.target)) {
    return {
      shouldHandle: false,
      shouldCapture: false,
      isInsideFloating: false,
    };
  }

  return {
    shouldHandle: true,
    shouldCapture: true,
    isInsideFloating: false,
  };
};
